import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import cn from 'classnames';

import { INewSupplementConfirmationControlsProps } from './NewSupplementConfirmationControls.interface';

import './style.scss';

const NewSupplementConfirmationControls: FC<INewSupplementConfirmationControlsProps> = ({
  className,
  confirmDisabled,
  confirmLabel,
  hideCancel,
  onCancel,
  submitFormId,
  submitting,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn('new-supplement-confirmation-controls', className)}>
      <Button
        className="new-supplement-confirmation-controls__button"
        variant="contained"
        type="submit"
        form={submitFormId}
        disabled={submitting || confirmDisabled}
      >
        {confirmLabel}
      </Button>

      {!hideCancel && (
        <Button
          className="new-supplement-confirmation-controls__button"
          variant="outlined"
          onClick={onCancel}
        >
          {t('common.cancel')}
        </Button>
      )}
    </div>
  );
};

export default NewSupplementConfirmationControls;
